import { useTranslation } from 'react-i18next';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { BulletPoints } from '@/common/components/BulletPoints/BulletPoints';
import { ModalLearning } from '@/common/components/ModalLearning/ModalLearning';
import { Translate } from '@/common/components/Translate/Translate';
import { tArray } from '@/common/utils/i18n';

export type TLearningCenterProps = {
  onClose: () => void;
};

export const CreditsLearningCenter = ({ onClose }: TLearningCenterProps) => {
  const { t } = useTranslation();
  const bulletPoints = tArray<string>(
    'dashboard.credits.home.learning_centre.how_list'
  );

  return (
    <ModalLearning.Root onClose={onClose} heightClass="h-[50rem]">
      <ModalLearning.Step
        title={t('dashboard.credits.home.learning_centre.about_title')}
        description={
          <Translate
            i18nKey="dashboard.credits.home.learning_centre.about_description"
            parent={BodyText}
          />
        }
      />
      <ModalLearning.Step
        title={t('dashboard.credits.home.learning_centre.how_title')}
        description={<BulletPoints points={bulletPoints} />}
      />
    </ModalLearning.Root>
  );
};
